import { z } from 'zod';
import { dataSourceKindSchema } from './data-connection-sources.js';
import { connectionProviderSchema } from './data-connections.js';

export const agentDataSourceRecordSchema = z.object({
  id: z.uuid(),
  agentId: z.coerce.number(),
  brandId: z.coerce.number().nullable(),
  dataSourceId: z.uuid(),
  isEnabled: z.boolean(),
  addedBy: z.coerce.number().nullable(),
  addedOn: z.coerce.date(),
  dataSource: z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string().nullable(),
    sourceQueryGuidance: z.string().nullable(),
    sourceIdentifier: z.string(),
    dataConnectionId: z.uuid(),
    kind: dataSourceKindSchema.optional(),
    dataConnection: z.object({
      identifier: z.uuid(),
      name: z.string(),
      connectionProvider: connectionProviderSchema.optional(),
    }),
  }),
});

export type AgentDataSourceRecord = z.infer<typeof agentDataSourceRecordSchema>;
